import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./measure.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./measure.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Injectable } from "@angular/core";
export let MeasureComponent = class MeasureComponent {
    constructor() { }
    initializeMeasureTool(mapView, Measure, Location) {
        const btnArea = document.getElementById("areaMeasure");
        const btnLocation = document.getElementById("idMeasure");
        const btnDistance = document.getElementById("linearMeasure");
        const btnRemove = document.getElementById("removeMeasure");
        btnArea.addEventListener("click", () => { switchToArea(); });
        btnDistance.addEventListener("click", () => { switchToDistance(); });
        btnLocation.addEventListener("click", () => { switchToLocation(); });
        btnRemove.addEventListener("click", () => { removeMeasurements(); });
        function switchToDistance() {
            Measure.activeTool = "distance";
            btnArea.classList.remove("active");
            btnLocation.classList.remove("active");
            btnDistance.classList.add("active");
            mapView.ui.remove(Location);
            mapView.ui.add(Measure, "bottom-left");
        }
        function switchToArea() {
            Measure.activeTool = "area";
            btnDistance.classList.remove("active");
            btnLocation.classList.remove("active");
            btnArea.classList.add("active");
            mapView.ui.remove(Location);
            mapView.ui.add(Measure, "bottom-left");
        }
        function switchToLocation() {
            Measure.activeTool = null;
            btnArea.classList.remove("active");
            btnDistance.classList.remove("active");
            btnLocation.classList.add("active");
            mapView.ui.remove(Measure);
            mapView.ui.add(Location, "bottom-left");
        }
        function removeMeasurements() {
            Measure.clear();
            btnArea.classList.remove("active");
            btnDistance.classList.remove("active");
            btnLocation.classList.remove("active");
            mapView.ui.remove([Measure, Location]);
        }
    }
    static ctorParameters = () => [];
};
MeasureComponent = __decorate([
    Injectable({
        providedIn: "root"
    }),
    Component({
        selector: "app-measure-tool",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], MeasureComponent);
